// extracted by mini-css-extract-plugin
module.exports = {"Story":"Story_Story__2vIcS","media":"Story_media__1hueT","map":"Story_map__1Rkyr","content":"Story_content__GpTm3"};